import PANEL_TYPES from "core/panelTypes";

const navs = [
  { name: "labels.containers", url: "/data-view/containers/", icon: "trash-can", role: "tech", panel_type: PANEL_TYPES.WASTE },
  { name: "labels.bridges", url: "/data-view/containers/", icon: "bridge-water", role: "tech", panel_type: PANEL_TYPES.BRIDGE },
  { name: "labels.island", url: "/data-view/islands/", icon: "boxes-stacked", role: "tech", panel_type: PANEL_TYPES.WASTE },
  { name: "labels.unloads", url: "/data-view/unloads/", icon: "truck-field", role: "admin", panel_type: PANEL_TYPES.WASTE },
]

export default navs